import { useCallback, useEffect, useState } from "react";

// Загрузка данных вкладки карточки клиента с защитой от гонок при переключении клиента
export default function useClientData(fetcher, userId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!userId) {
      setData(null);
      return;
    }
    let ignore = false;
    setLoading(true);
    setError(null);
    fetcher(userId)
      .then((res) => {
        if (!ignore) setData(res);
      })
      .catch((e) => {
        console.error(e);
        if (!ignore) setError(e.message || "Ошибка загрузки");
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [fetcher, userId, version]);

  const reload = useCallback(() => setVersion((v) => v + 1), []);

  return { data, setData, loading, error, reload };
}
